import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  const clearLocalStorageWithPrefix = (prefix: string) => {
    for (let key in localStorage) {
      if (key.startsWith(prefix)) {
        localStorage.removeItem(key);
      }
    }
  }

  useEffect(() => {
    clearLocalStorageWithPrefix(process.env.REACT_APP_BASENAME!);
    navigate('/login');
  }, []);

  return <></>;
};

export default Logout;
